import { useCallback, useRef } from 'react';

/**
 *
 * @param fn
 * @param delay
 */
const useThrottle = <T extends (...args: any[]) => void>(fn: T, delay: number = 300) => {
    const fnRef = useRef<T>(fn);
    const lastCalledAtRef = useRef(0);

    fnRef.current = fn;

    return useCallback(
        (...args: Parameters<T>) => {
            const now = Date.now();

            //delay 이내의 재호출은 무시
            if (now - lastCalledAtRef.current < delay) {
                return;
            }

            lastCalledAtRef.current = now;
            return fnRef.current(...args);
        },
        [delay],
    );
};

export { useThrottle };
